// actionTypes.ts

export const SET_USER = 'SET_USER';
export const SET_PANEL_OPEN = 'SET_PANEL_OPEN';
export const SET_PANEL_EDIT_STATE = 'SET_PANEL_EDIT_STATE';
export const SET_UPDATED_COMPANY = 'SET_UPDATED_COMPANY';
export const SET_VOUCHER = 'SET_VOUCHER';
export const SET_CART = 'SET_CART';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const SET_PRODUCT_DEPOT_INFOS = 'SET_PRODUCT_DEPOT_INFOS';
export const UPDATE_PRODUCT_DEPOT_INFOS = 'UPDATE_PRODUCT_DEPOT_INFOS';
export const SET_SUB_SUB_CATEGORIES = 'SET_SUB_SUB_CATEGORIES';
export const SET_DEPOTS = 'SET_DEPOTS';
export const UPDATE_DEPOT = 'UPDATE_DEPOT';
export const ADD_DEPOT = 'ADD_DEPOT';
export const SET_QUOTES = 'SET_QUOTES';
export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const REMOVE_QUOTE = 'REMOVE_QUOTE';
export const ADD_QUOTE = 'ADD_QUOTE';
export const SET_INVOICES = 'SET_INVOICES';
export const UPDATE_INVOICE = 'UPDATE_INVOICE';
export const ADD_INVOICE = 'ADD_INVOICE';
export const SET_PROFORMA_INVOICES = 'SET_PROFORMA_INVOICES';
export const UPDATE_PROFORMA_INVOICE = 'UPDATE_PROFORMA_INVOICE';
export const SET_PURCHASE_ORDERS = 'SET_PURCHASE_ORDERS';
export const UPDATE_PURCHASE_ORDER = 'UPDATE_PURCHASE_ORDER';
export const ADD_PURCHASE_ORDER = 'ADD_PURCHASE_ORDER';
export const SET_PURCHASE_ORDER_STATUSES = 'SET_PURCHASE_ORDER_STATUSES';

// Create Program action types
export const CLEAR_CREATE_PROGRAM = 'CLEAR_CREATE_PROGRAM';
export const SET_CREATE_PROGRAM_PROGRAM = 'SET_CREATE_PROGRAM_PROGRAM';
export const ADD_CREATE_PROGRAM_LINE = 'ADD_CREATE_PROGRAM_LINE';
export const UPDATE_CREATE_PROGRAM_LINE = 'UPDATE_CREATE_PROGRAM_LINE';
export const REMOVE_CREATE_PROGRAM_LINE = 'REMOVE_CREATE_PROGRAM_LINE';
export const MOVE_CREATE_PROGRAM_LINE_UP = 'MOVE_CREATE_PROGRAM_LINE_UP';
export const MOVE_CREATE_PROGRAM_LINE_DOWN = 'MOVE_CREATE_PROGRAM_LINE_DOWN';

// Programs list action types
export const SET_PROGRAMS_LIST = 'SET_PROGRAMS_LIST';
export const ADD_PROGRAM = 'ADD_PROGRAM';
export const UPDATE_PROGRAM = 'UPDATE_PROGRAM';
export const REMOVE_PROGRAM = 'REMOVE_PROGRAM';

// Applications reducer action types
export const SET_APPLICATIONS_LIST = 'SET_APPLICATIONS_LIST';
export const ADD_APPLICATION = 'ADD_APPLICATION';
export const UPDATE_APPLICATION = 'UPDATE_APPLICATION';
export const SET_CURRENT_APPLICATION = 'SET_CURRENT_APPLICATION';

// Operating Costs (Applications)
export const SET_OPERATING_COSTS = 'SET_OPERATING_COSTS';
export const ADD_OPERATING_COST = 'ADD_OPERATING_COST';
export const UPDATE_OPERATING_COST = 'UPDATE_OPERATING_COST';
export const REMOVE_OPERATING_COST = 'REMOVE_OPERATING_COST';

/* ───────── Widget dashboard ───────── */
export const RDW_SET_LAYOUT = 'dashboard/SET_WIDGET_LAYOUT' as const;
export const RDW_UPDATE_SIZE = 'dashboard/UPDATE_WIDGET_SIZE' as const;

export const RDW_ADD_WIDGET = 'dashboard/ADD_WIDGET' as const;
export const RDW_REMOVE_WIDGET = 'dashboard/REMOVE_WIDGET' as const;

/* ───────── Global Date Filter ───────── */
export const DF_SET_PRESET_RANGE = 'dateFilter/SET_PRESET_RANGE' as const;
export const DF_SET_CUSTOM_RANGE = 'dateFilter/SET_CUSTOM_RANGE' as const;
